var map = {
	"./btob.jpg": "9kiB",
	"./btoc.jpg": "ODFm",
	"./commerce.jpg": "Q8DG",
	"./construction.jpg": "OQdc",
	"./estate.jpg": "+B0P",
	"./finance.jpg": "JXJ1",
	"./healthcare.jpg": "EGkc",
	"./logistics.jpg": "YdGr",
	"./manufacturing.jpg": "LGCy",
	"./media.jpg": "7cn7",
	"./outsourcing.jpg": "cbmE",
	"./professional.jpg": "aUNI",
	"./retail.jpg": "10+l",
	"./software.jpg": "3aLy",
	"./travel.jpg": "28/5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "VdOj";